import {
  fetchBrands as actionFetchBrands,
  fetchProviders as actionFetchProviders,
  fetchTags as actionFetchTags,
} from "@shared/actions/games";
import {
  BRANDS_FETCH,
  BRANDS_FETCH_FAILURE,
  BRANDS_FETCH_SUCCESS,
  GAME_RUN,
  GAME_RUN_FAILURE,
  GAME_RUN_SUCCESS,
  GAMES_FETCH,
  GAMES_FETCH_FAILURE,
  GAMES_FETCH_SUCCESS,
  PROVIDERS_FETCH,
  PROVIDERS_FETCH_FAILURE,
  PROVIDERS_FETCH_SUCCESS,
  TAGS_FETCH,
  TAGS_FETCH_FAILURE,
  TAGS_FETCH_SUCCESS,
} from "@shared/constants";
import { serverErrorHandler } from "@shared/reducers/error";
import { getCurrentLanguage } from "@shared/utils/languages";
import { checkResponse, post } from "@shared/utils/server";
import { all, call, fork, put, takeLatest } from "redux-saga/effects";

export function* fetchGames({ payload }) {
  try {
    const { hallId } = payload;
    const response = yield call(post, [
      {
        method: "Game.list",
        args: {},
      },
    ]);
    checkResponse(response);
    yield put({
      type: GAMES_FETCH_SUCCESS,
      payload: response[0].list,
    });

    yield put(actionFetchProviders(hallId));
    yield put(actionFetchBrands(hallId));
    yield put(actionFetchTags(hallId));
  } catch (error) {
    yield put({
      type: GAMES_FETCH_FAILURE,
      payload: error,
    });
  }
}

export function* fetchProviders() {
  try {
    const response = yield call(post, [
      {
        method: "Game.providerList",
        args: {},
      },
    ]);

    checkResponse(response);

    yield put({
      type: PROVIDERS_FETCH_SUCCESS,
      payload: response[0],
    });
  } catch (error) {
    yield put({
      type: PROVIDERS_FETCH_FAILURE,
      payload: error,
    });
  }
}

export function* fetchBrands({ bankGroupStringId = 0 }) {
  try {
    const response = yield call(post, [
      {
        method: "Game.sectionList",
        args: { bankGroupStringId },
      },
    ]);

    checkResponse(response);

    yield put({
      type: BRANDS_FETCH_SUCCESS,
      payload: response[0].list,
    });
  } catch (error) {
    yield put({
      type: BRANDS_FETCH_FAILURE,
      payload: error,
    });
  }
}

export function* fetchTags({ bankGroupStringId = 0 }) {
  try {
    const response = yield call(post, [
      {
        method: "Game.tagList",
        args: { bankGroupStringId },
      },
    ]);

    checkResponse(response);

    yield put({
      type: TAGS_FETCH_SUCCESS,
      payload: response[0].list,
    });
  } catch (error) {
    yield put({
      type: TAGS_FETCH_FAILURE,
      payload: error,
    });
  }
}

export function* runGame({ payload: params }) {
  try {
    if (params.demo) {
      params["demo_balance"] = 1_000;
    }

    const response = yield call(post, [
      {
        method: "Game.run",
        args: {
          deviceType: "desktop",
          ...params,
          lang: getCurrentLanguage(),
        },
      },
    ]);

    checkResponse(response);

    yield put({
      type: GAME_RUN_SUCCESS,
      payload: response[0].link,
    });
  } catch (error) {
    yield put({
      type: GAME_RUN_FAILURE,
      payload: serverErrorHandler(error?.message),
    });
  }
}

function* watchGamesFetch() {
  yield takeLatest(GAMES_FETCH, fetchGames);
}

function* watchProvidersFetch() {
  yield takeLatest(PROVIDERS_FETCH, fetchProviders);
}

function* watchBrandsFetch() {
  yield takeLatest(BRANDS_FETCH, fetchBrands);
}

function* watchTagsFetch() {
  yield takeLatest(TAGS_FETCH, fetchTags);
}

function* watchGameRun() {
  yield takeLatest(GAME_RUN, runGame);
}

export default function* GamesSaga() {
  yield all([
    fork(watchGamesFetch),
    fork(watchProvidersFetch),
    fork(watchBrandsFetch),
    fork(watchTagsFetch),
    fork(watchGameRun),
  ]);
}
